<template>
  <span v-if="payHandlerType || payType">
    <span
      class="fa-layers align-middle"
      style="font-size:215%"
      :class="{'mr-2': $dir.ltr, 'ml-2': $dir.rtl}"
    >
      <font-awesome-icon icon="circle" fixed-width :class="'text-' + (payHandlerType ? payHandlerType.variant : payType.variant)"/>
      <font-awesome-icon :icon="payHandlerType ? payHandlerType.icon : payType.icon" fixed-width class="fa-inverse" transform="shrink-9"/>
    </span>

    <template v-if="prefix">{{ prefix }}</template>
    
    {{ payHandlerType ? payHandlerType.text : payType.text }}
  </span>
</template>

<script>
export default {
  name: 'PayHandlerDisplay',
  props: {
    item: { type: Object, required: true },
    prefix: String
  },
  data () {
    return {
      handlerTypes: [
        { value: 110, text: this.$t('payHandlers.credit'), icon: 'wallet', variant: 'danger' },
        { value: 210, text: this.$t('payHandlers.bankReceipt'), icon: 'receipt', variant: 'dark' },
        { value: 310, text: this.$t('payHandlers.zarinpalIpg'), icon: 'globe', variant: 'info' },
        { value: 311, text: this.$t('payHandlers.zarinpalSandboxIpg'), icon: 'globe', variant: 'info' },
        { value: 320, text: this.$t('payHandlers.pasargadIpg'), icon: 'globe', variant: 'info' },
        { value: 330, text: this.$t('payHandlers.mellatIpg'), icon: 'globe', variant: 'info' },
        { value: 340, text: this.$t('payHandlers.ayandehIpg'), icon: 'globe', variant: 'info' },
        { value: 510, text: this.$t('payHandlers.check'), icon: 'money-check-alt', variant: 'success' },
        { value: 610, text: this.$t('payHandlers.barter'), icon: 'sync-alt', variant: 'indigo' }
      ],
      payTypes: [
        { value: 100, text: this.$t('payHandlers.credit'), icon: 'wallet', variant: 'danger' },
        { value: 200, text: this.$t('payHandlers.bankReceipt'), icon: 'receipt', variant: 'dark' },
        { value: 300, text: this.$t('payHandlers.ipg'), icon: 'globe', variant: 'info' },
        { value: 500, text: this.$t('payHandlers.check'), icon: 'money-check-alt', variant: 'success' },
        { value: 600, text: this.$t('payHandlers.barter'), icon: 'sync-alt', variant: 'indigo' }
      ]
    }
  },
  computed: {
    payHandlerType () {
      return this.handlerTypes.find(i => i.value === this.item.payHandlerType)
    },
    payType () {
      return this.payTypes.find(i => i.value === this.item.payType)
    }
  }
}
</script>
